import { render, staticRenderFns } from "./fflearner.vue?vue&type=template&id=5b5fe0dc&"
import script from "./fflearner.vue?vue&type=script&lang=js&"
export * from "./fflearner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports